import ConfirmDialogue from './ConfirmDialogue';
import showConfirmDialogue from './showConfirmDialogue';
import ConfirmDialogRoot from './ConfirmDialogRoot';

export default ConfirmDialogue;
export { showConfirmDialogue, ConfirmDialogRoot };
